import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1168 1058",
  "content": "<symbol viewBox=\"0 0 1168 1058\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\r\n<path d=\"M381.964 1005.75C592.445 1127.48 872.589 1036.12 1089.32 728.077C1306.05 420.038 1040.44 95.2083 685.655 23.7886C391.923 -35.3408 39.2894 0.937023 9.18417 343.878C-25.3592 737.375 32.8704 803.867 381.964 1005.75Z\" fill=\"#4C76D2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol